export default __webpack_public_path__ + "static/thermiclance-what-is-thermic-lance-4d9c0eedc7578dbc8298990cd5a2be8b.gif";